import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=a5ece394&scoped=true&"
import script from "./CustomDialog.vue?vue&type=script&lang=js&"
export * from "./CustomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ece394",
  null
  
)

export default component.exports